import { render } from "./ConfigurationForm.vue?vue&type=template&id=fd4c81ec&scoped=true&ts=true"
import script from "./ConfigurationForm.vue?vue&type=script&lang=ts"
export * from "./ConfigurationForm.vue?vue&type=script&lang=ts"

import "./ConfigurationForm.vue?vue&type=style&index=0&id=fd4c81ec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.5.5__webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4c81ec"]])

export default __exports__